<!-- ================管理端-营在规划-五馆研学活动====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">研学活动列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建研学活动</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">所属研学营:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.campKey" placeholder="请选择">
                        <el-option v-for="item in campList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">参与对象:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.excursionAudience" placeholder="请选择">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictValue" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.excursionTitle" placeholder="请输入活动标题">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column label="活动标题" align="center" prop="excursionTitle" width="240">
                    <template #default="scope">
                        <div :title="scope.row.excursionTitle" @click="handleDetail(scope.row)"
                             style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.excursionTitle }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" label="所属研学营" align="center" prop="campKey">
                    <template #default="scope">
                        <div :title="campName(scope.row.campKey)" class="text-one cursor">
                            {{ campName(scope.row.campKey) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="活动主题" align="center" prop="excursionTheme" width="240">
                    <template #default="scope">
                        <div :title="scope.row.excursionTheme"
                             style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.excursionTheme }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" label="活动参与对象" align="center" prop="excursionAudience">
                    <template #default="scope">
                        <div :title="scope.row.excursionAudience" class="text-one cursor">
                            {{ scope.row.excursionAudienceName }}学生
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="查看平台" align="center" prop="excursionAudience">
                    <template #default="scope">
                        <div :title="scope.row.businessPlatformName" class="text-one cursor">
                            {{ scope.row.businessPlatformName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="300" align="center" label="活动时间" prop="excursionTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="160" label="研学地点" align="center" prop="excursionAddress" />
                <el-table-column width="100" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="80" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleDetail(scope.row)">查看</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                          confirm-button-text="是"
                                          cancel-button-text="否"
                                          icon-color="#626AEF"
                                          title="确定删除?"
                                          @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>

</template>
<script>
import {deleteExcursion, pageExcursion} from "@/api/admin/excursion";
import {queryDict} from "@/api/admin/dict";
import { timestampToTime } from "@/utils/date";
export default {
    components: {},
    name: "excursionIndex",
    data() {
        return {
            timestampToTime,
            loading: false,
            /*分页查询五馆研学活动*/
            queryParams: {
                excursionTitle: '',
                campKey: '',
                excursionAudience: '',
                pageNum: 1,
                pageSize: 10,
            },
            dataList: [],
            total: 0,
            campList: [],
            periodList: [],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.handleQueryDict();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        handleQueryDict() {
            queryDict({ code: 'museum_camp' }).then(res => {
                if (res.data.code === 1) {
                    this.campList = res.data.data;
                }
            })
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                }
            })
        },
        campName(campKey) {
            const camp = this.campList.find(item => item.dictKey === campKey);
            return camp ? camp.dictValue : campKey;
        },
        handleQuery() {
            this.pageList(null);
        },
        pageList(e) {
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageExcursion(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                } else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleDelete(row) {
            deleteExcursion({ excursionId: row.excursionId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleCreate() {
            this.$router.push({
                path: "/excursionCreate",
            });
        },
        handleUpdate(row) {
            this.$router.push({
                path: "/excursionCreate",
                query: {
                    excursionId: row.excursionId,
                }
            });
        },
        handleDetail(row) {
            this.$router.push({
                path: "/excursionDetail",
                query: {
                    excursionId: row.excursionId,
                }
            });
        },
    },
}
</script>
<style scoped>
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn {
    background-color: #377f7f!important;
    color: #fff!important;
}
</style>
